// extracted by mini-css-extract-plugin
module.exports = {"pageSection":"PageSection_pageSection__Izeoq"};